import { Button, IconNode, Modal, Typography, CheckboxLabel } from '@components/base';
import { useForm, Controller, useWatch } from 'react-hook-form';
import Images from '@assets/images';
import { useEffect, useMemo } from 'react';
import css from './index.module.scss';

interface GenerateCOOModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { show_trademark: boolean; show_product_name: boolean }) => void;
  initialTrademark?: boolean;
  initialProductName?: boolean;
}

const GenerateCOOModal = (props: GenerateCOOModalProps) => {
  const { open, onClose, onSubmit, initialTrademark = true, initialProductName = false } = props;

  const { control, handleSubmit, watch, formState, setValue } = useForm({
    defaultValues: {
      show_trademark: initialTrademark,
      show_product_name: initialProductName
    }
  });

  const showTrademark = useWatch({ name: 'show_trademark', control });
  const showProductName = useWatch({ name: 'show_product_name', control });
  useEffect(() => {
    if (!showTrademark && showProductName) {
      setValue('show_product_name', false);
    }
  }, [showTrademark, showProductName]);

  const handleFormSubmit = handleSubmit((data) => {
    onSubmit(data);
  });

  return (
    <Modal open={open} onClose={onClose}>
      <div className={css.modalWrapper}>
        <section className={css.modalHeader}>
          <Typography variant="h4">Generate Certificate of Origin</Typography>
          <IconNode
            src={Images.crossBlack}
            alt="close icon"
            component="button"
            className={css.closeButton}
            onClick={onClose}
          />
        </section>
        <form noValidate onSubmit={handleFormSubmit} className={css.formWrapper}>
          <section className={css.modalContent}>
            <div className={css.fieldWrapper}>
              <Controller
                name="show_trademark"
                control={control}
                render={({ field }) => (
                  <CheckboxLabel
                    {...field}
                    label="Show Trademark"
                    value={`${field.value}`}
                    checked={field.value}
                    disabled
                  />
                )}
              />
              <Controller
                name="show_product_name"
                control={control}
                render={({ field }) => (
                  <CheckboxLabel
                    {...field}
                    label="Include Product Name Along with Trademark Name"
                    value={`${field.value}`}
                    checked={field.value}
                  />
                )}
              />
            </div>
          </section>
          <section className={css.modalFooter}>
            <Button
              variant="outlined-secondary"
              onClick={onClose}
              disabled={formState.isSubmitting}
            >
              Cancel
            </Button>
            <Button type="submit" disabled={formState.isSubmitting}>
              Generate
            </Button>
          </section>
        </form>
      </div>
    </Modal>
  );
};

export default GenerateCOOModal;
